import { useContext } from 'react'

import { CountriesContext } from '@percent/education-hosted-form/context/countries/CountriesContext'

export const useCountries = () => {
  const context = useContext(CountriesContext)

  if (context === undefined) {
    throw new Error('useCountries must be used within countriesContextController')
  }

  return context
}
